import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { toBase64 } from "@smithy/util-base64";
import { isReadableStream } from "../stream-type-check";
import { ChecksumStream } from "./ChecksumStream.browser";
export var createChecksumStream = function createChecksumStream(_ref) {
  var expectedChecksum = _ref.expectedChecksum,
    checksum = _ref.checksum,
    source = _ref.source,
    checksumSourceLocation = _ref.checksumSourceLocation,
    base64Encoder = _ref.base64Encoder;
  if (!isReadableStream(source)) {
    var _source$constructor$n, _source$constructor;
    throw new Error("@smithy/util-stream: unsupported source type ".concat((_source$constructor$n = source === null || source === void 0 ? void 0 : (_source$constructor = source.constructor) === null || _source$constructor === void 0 ? void 0 : _source$constructor.name) !== null && _source$constructor$n !== void 0 ? _source$constructor$n : source, " in ChecksumStream."));
  }
  var encoder = base64Encoder !== null && base64Encoder !== void 0 ? base64Encoder : toBase64;
  if (typeof TransformStream !== "function") {
    throw new Error("@smithy/util-stream: unable to instantiate ChecksumStream because API unavailable: ReadableStream/TransformStream.");
  }
  var transform = new TransformStream({
    start: function start() {},
    transform: function transform(chunk, controller) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                checksum.update(chunk);
                controller.enqueue(chunk);
              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    flush: function flush(controller) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var digest, received, error;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return checksum.digest();
              case 2:
                digest = _context2.sent;
                received = encoder(digest);
                if (expectedChecksum !== received) {
                  error = new Error("Checksum mismatch: expected \"".concat(expectedChecksum, "\" but received \"").concat(received, "\"") + " in response header \"".concat(checksumSourceLocation, "\"."));
                  controller.error(error);
                } else {
                  controller.terminate();
                }
              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  });
  source.pipeThrough(transform);
  var readable = transform.readable;
  Object.setPrototypeOf(readable, ChecksumStream.prototype);
  return readable;
};